(function () {
  let slider;

  const initAnnBar = () => {
    const annBar = document.querySelector(".announcement-section");

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      if (annBar) intersectionObserver.observe(annBar);
      if (annBar) resizeObserver.observe(annBar);
    };

    createObservers();

    const texts = annBar.querySelectorAll(".announcement-bar__text");
    if (texts.length > 1) {
      const setWrapperWidth = () => {
        const wrapper = annBar.querySelector(".swiper-wrapper");
        if (!wrapper) return;

        wrapper.style.maxWidth = "none";
        const widths = [
          ...annBar.querySelectorAll(".announcement-bar__text"),
        ].map((el) => el.getBoundingClientRect().width);
        const maxWidth = Math.max(...widths);
        wrapper.style.maxWidth = maxWidth + "px";

        if (slider) slider.update();
      };

      setWrapperWidth();

      if (!slider) {
        const sliderel = annBar.querySelector(".js-announcement-slider");
        const hasSliderAutoplay =
          sliderel.getAttribute("data-autoplay") === "true";
        const pauseAutoplayOnHover =
          sliderel.getAttribute("data-autoplay-pause-on-hover") === "true";
        const autoplayDelay = Number(sliderel.dataset.autoplayDelay || 8000);

        slider = new Swiper(annBar.querySelector(".js-announcement-slider"), {
          loop: true,
          slidesPerView: 1,
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true,
          },
          autoplay: hasSliderAutoplay
            ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseAutoplayOnHover,
              }
            : false,
          navigation: {
            nextEl: annBar.querySelector(".slider-nav-button--next"),
            prevEl: annBar.querySelector(".slider-nav-button--prev"),
          },
        });
      }
      let resizeTimeout;

      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          setWrapperWidth();
        }, 100);
      });
    }
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
